import FavoriteMenu from './module/favorite'
const API = { ...FavoriteMenu}
export default API;